export default __webpack_public_path__ + "static/media/1213 knife block B side.5a4f4f70.png";